import { BackButton } from './Icons';
import { EncryptedLabel } from './EncryptedLabel';

/**
 * TODO: Add real data to this component.
 * @param param0
 * @returns
 */
export function InfoView({
  setPage,
}: {
  setPage: (page: 'pay' | 'info') => void;
}) {
  return (
    <>
      <div
        class="back"
        onClick={(e) => {
          e.preventDefault();
          setPage('pay');
        }}
      >
        <BackButton />
      </div>

      <div class="details" style={{ marginTop: '-1rem' }}>
        <div class="helpHeader">Payment Information</div>
        <EncryptedLabel />
        <div class="divider" style={{ marginTop: '-1rem' }}></div>
      </div>
    </>
  );
}
